import 'moment/locale/fi';
import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils from 'react-day-picker/moment';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux';
import uuidv1 from 'uuid/v1';
import { requestSaveTask } from '../../actions/task';
import { getLocalizedString } from '../../localization/LocalizedString';
import Button from '../forms/Button';
import '../forms/DayPickerInput.css';
import Select from '../forms/Select';
import TextArea from '../forms/TextArea';
import './ManualTask.css';
import TimePicker from '../../views/24hTimePicker/TimePicker';
import dayjs from 'dayjs';
import moment from 'moment';

class ManualTask extends React.Component {
  constructor(props) {
    super(props);
    this.requestId = uuidv1();
    this.taskId = uuidv1();
    this.state = {
      startTime: '',
      endTime: ''
    };
  }

  onSubmit(evt) {
    evt.preventDefault();
    const formData = new FormData(evt.target);
    const { startTime, endTime, start } = this.state;
    const data = {
      requestId: this.requestId,
      taskId: this.taskId,
      sequenceNumber: 0,
      destinationId: this.props.destination.id,
      serviceSiteId: this.props.serviceSite.id,
      taskType: 'manual',
    };

    for (const [key, value] of formData.entries()) {
      data[key] = value;
    }
    const startDate = new Date(startTime);
    const endDate = new Date(endTime);

    const taskStartTime = `${startDate.getHours()}:${startDate.getMinutes()}`;
    const taskEndTime = `${endDate.getHours()}:${endDate.getMinutes()}`;

    data.startTime = moment(`${start} ${taskStartTime}`).toDate();
    data.endTime = moment(`${start} ${taskEndTime}`).toDate();
    const { requestSaveTask, translate } = this.props;
    if(start !== undefined) {
      requestSaveTask(JSON.stringify(data), (e) => toast.error(translate('new_task.save_failed')), () => this.props.onSaved());
    } else {
      this.setState({ editStartDate: "Invalid Date", })
    }
  }

  getServiceOptions() {
    const { currentLanguage, serviceSite } = this.props;
    const { services } = serviceSite || {};

    return (services || []).map(service => ({
      value: service.id,
      text: getLocalizedString(service.name, currentLanguage),
    }));
  }

  onHandleChange24hTimePicker = (evt) => {
    if(evt.isStartTime) {
      this.setState({ startTime: evt.pickedTime });
    } else {
      this.setState({ endTime: evt.pickedTime });
    }
  };

  taskDateChange = (date, modifiers, dayPickerInput) => {
    const taskStrDate = this.getTaskDate(dayPickerInput.getInput().value.trim());
    if(taskStrDate !== undefined && taskStrDate !== "") {
      const manualTaskDateString = taskStrDate.trim();
      const taskDateParts = taskStrDate.split(".")
      let manualTaskDate = dayjs(`${taskDateParts[2]}-${taskDateParts[1]}-${taskDateParts[0]}`).format('YYYY-MM-DD');
      if(manualTaskDate !== 'Invalid Date') {
        this.setState({
          editStartDate: manualTaskDateString,
          start: manualTaskDate,
        });
      }
    } else if(date !== undefined) {
      this.setState({
        editStartDate: dayjs(date).format('DD.MM.YYYY'),
        start: dayjs(date).format('YYYY-MM-DD') || null,
      });
    }
  };

  getTaskDate = (strTaskDate) => {
    if(strTaskDate.includes(".") && (strTaskDate.length === 10 || strTaskDate.length === 8 || strTaskDate.length === 6)) {
      const taskDateParts = strTaskDate.split(".");
      if(taskDateParts.length === 3) {
        if(taskDateParts[0] !== undefined && taskDateParts[1] !== undefined && taskDateParts[2] !== undefined) {
          if(taskDateParts[0].length === 2 && taskDateParts[1].length === 2 && taskDateParts[2].length === 4) {
            return taskDateParts[0] + "." + taskDateParts[1] + "." + taskDateParts[2];
          } else if((taskDateParts[0].length === 1 || taskDateParts[1].length === 1) && taskDateParts[2].length === 4) {
            return `0${taskDateParts[0]}.0${taskDateParts[1]}.${taskDateParts[2]}`
          }
        }
      }
    }
    return "";
  }

  render() {
    const { translate, currentLanguage } = this.props;
    const { editStartDate } = this.state;
    return (
      <form onSubmit={this.onSubmit.bind(this)}>

        <div>
          <div className="row">
            <div className="col-sm-12">
              <h1>{translate('new_task.title')}</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-lg-9">
              <Select
                name="serviceId"
                data={this.getServiceOptions()}
                placeholder={this.props.translate('new_task.service_placeholder')}
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="row">
                <div className="col-sm-12"><h2>{translate('new_task.date')}</h2></div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <DayPickerInput
                    onDayChange={this.taskDateChange}
                    placeholder="DD.MM.YYYY"
                    value={editStartDate}
                    inputProps={{
                      required: 'required',
                      name: 'date',
                    }}
                    dayPickerProps={{
                      locale: currentLanguage,
                      localeUtils: MomentLocaleUtils,
                    }} />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 time-picker-24h-block">
              <div className="row">
                <div className="col-sm-12"><h2>{translate('new_task.start_stop_time')}</h2></div>
              </div>
              <div className="row">
                <div className="col-xs-9">
                  <TimePicker name="start"
                              selectedTime={this.onHandleChange24hTimePicker}
                              required
                              stepValue={0}
                              isStartTime={true} />
                </div>
                <div className="time-selector-seperator"><span>&mdash;</span></div>
                <div className="col-xs-9 end-24h-time-picker">
                  <TimePicker name="end"
                              selectedTime={this.onHandleChange24hTimePicker}
                              required
                              stepValue={0}
                              isStartTime={false} />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <h2>{translate('new_task.description')}</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <TextArea name="taskInfo" rows={10} placeholder={translate('new_task.description_placeholder')} />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <Button onClick={this.props.onCancel}>{translate('form.reset')}</Button>
            </div>
            <div className="col-sm-6">
              <Button>{translate('form.submit')}</Button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  translate: getTranslate(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  requestSaveTask,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualTask);



// WEBPACK FOOTER //
// ./src/components/servicesite/ManualTask.js